import { addCountryCode, requestContactDetail } from "services";
import { useAsyncAction } from "./useAsyncAction";

interface DownloadDocumentApiPayloadType {
  propertyUuid: string;
  userName: string;
  userEmail?: string;
  userMobile: string;
}

export function useRequestContactDetailsApi() {
  return useAsyncAction(
    async ({
      propertyUuid,
      userName,
      userEmail,
      userMobile,
    }: DownloadDocumentApiPayloadType) => {
      const payload: any = {
        property_uuid: propertyUuid,
        name: userName ? userName : "User",
        ...(userEmail?.trim()?.toLowerCase() && {
          email: userEmail?.trim()?.toLowerCase(),
        }),
        mobile: userMobile ? addCountryCode(userMobile) : "NA",
      };

      await requestContactDetail(payload);
      return true;
    },
  );
}
